import React from 'react'
import { Link } from 'react-router-dom'

const ListRow = ({tutorialObj}) => {

  return (

    <div key={tutorialObj.title}>
      <div className="listRow">
        <div className="tutorialTitle">{tutorialObj.title}</div> by
        <div className="tutorialUsername"> {tutorialObj.username} ({tutorialObj.numCards} Cards)</div>
        <div className="tutorialDescription">{tutorialObj.description}</div>
        <div className="takeItBtnCont">
          <Link
            className="takeItLink"
            rel="noopener noreferrer"
            to={"/" + tutorialObj.tutorialId.toString()}
          >
            <div className="">
              <span className="takeItBtn">Take it &raquo;</span>
            </div>
          </Link>
        </div>
        {tutorialObj.canDrillIt !== 0 &&
          <div className="drillItBtnCont">
            <Link
              className="drillItLink"
              rel="noopener noreferrer"
              to={"/drilltable/" + tutorialObj.tutorialId.toString()}
            >
              <div className="">
                <span className="takeItBtn">Drill it &raquo;</span>
              </div>
            </Link>
          </div>
        }
      </div>
      <hr/>
    </div>

  )
}

export default ListRow
